import "./style.css";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { failed, success } from "@components/Common/Toastify";
import Button from "@components/Common/Button";
import AuthPagesLayout from "@components/Layouts/AuthPagesLayout";

// Dummy function to simulate backend call for saving bank info
const saveBankDetails = async (stripeToken: string) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (stripeToken) {
        resolve({ message: "Bank details saved successfully" });
      } else {
        reject({ message: "Stripe token is missing " });
      }
    }, 1000);
  });
};

const BankDetails = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBtnLoading(true);

    if (!stripe || !elements) {
      failed("Stripe has not loaded yet.");
      setBtnLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      failed("Card element not found.");
      setBtnLoading(false);
      return;
    }

    const { token, error } = await stripe.createToken(cardElement);

    if (error) {
      failed(error.message || "Failed to get Stripe token");
      setBtnLoading(false);
      return;
    }

    try {
      const res: any = await saveBankDetails(token.id);
      success(res.message);
      navigate("/app/dashboard");
    } catch (err: any) {
      failed(err.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <AuthPagesLayout heading="Bank Details">
      <form className="auth-form" onSubmit={handleSubmit}>
        <div style={{ marginBottom: "1rem" }}>
          <label>Card Details</label>
          <div className="card-element-container">
            <CardElement options={{ hidePostalCode: true }} />
          </div>
        </div>
        <div className="btn-wrap">
          <Button
            type="submit"
            className="custom-btn"
            style={{ width: "100%" }}
            isLoading={btnLoading}
          >
            Submit Bank Details
          </Button>
        </div>
        <div className="privacy-div">
          <p>
            Back to Signup?
            <span>
              <Link to="/auth/signup" title="Signup">
                Signup
              </Link>
            </span>
          </p>
        </div>
      </form>
    </AuthPagesLayout>
  );
};

export default BankDetails;
